(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["checkout-guard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('checkout-guard-component')) {
    class CheckoutGuardComponent extends HTMLElement {
      connectedCallback() {
        this.#bindButton();
        this.observer = new MutationObserver(() => this.#bindButton());
        this.observer.observe(document.body, { childList: true, subtree: true });
        window.addEventListener('pagehide', this.#clearRecovery);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.#handleClick);
        this.observer?.disconnect();
        window.removeEventListener('pagehide', this.#clearRecovery);
        this.#clearRecovery();
      }

      #handleClick = () => {
        this.#clearRecovery();
        this.status.hidden = true;
        this.#log('checkout_click');
        this.recoveryTimer = window.setTimeout(() => {
          this.status.hidden = false;
        }, 4000);
      };

      #bindButton() {
        const nextButton = document.getElementById('checkout');
        if (nextButton === this.button) return;

        this.button?.removeEventListener('click', this.#handleClick);
        this.button = nextButton;
        this.button?.addEventListener('click', this.#handleClick);

        if (!this.button) return;

        const statusId = 'checkout-navigation-status';
        this.status = document.getElementById(statusId);
        if (!this.status) {
          this.status = document.createElement('p');
          this.status.id = statusId;
          this.status.className = 'checkout-navigation-status';
          this.status.setAttribute('role', 'status');
          this.status.setAttribute('aria-live', 'polite');
          this.status.hidden = true;
          this.status.textContent = 'Checkout is taking longer than usual. Please try again, or open this page in Chrome or Safari.';
          this.button.insertAdjacentElement('afterend', this.status);
        }
      }

      #clearRecovery = () => {
        window.clearTimeout(this.recoveryTimer);
        this.recoveryTimer = undefined;
      };

      #log(eventName) {
        try {
          const sessionId = (() => {
            try {
              const key = 'silah_session_id';
              let id = sessionStorage.getItem(key);
              if (!id) {
                id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
                sessionStorage.setItem(key, id);
              }
              return id;
            } catch {
              return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
            }
          })();

          const payload = JSON.stringify({
            shop: window.location.hostname,
            eventName,
            sessionId,
            path: window.location.pathname + window.location.search,
            referrer: document.referrer || null,
          });
          const endpoint = 'https://silah.aiwahconnect.com/track';

          // Beacons are designed for page-unload-adjacent telemetry and avoid the
          // cross-origin JSON preflight that a fetch can create in an in-app browser.
          if (navigator.sendBeacon?.(endpoint, new Blob([payload], { type: 'text/plain;charset=UTF-8' }))) {
            return;
          }

          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body: payload,
            keepalive: true,
            mode: 'no-cors',
          }).catch(() => {
            // Analytics endpoint unreachable — never let this block checkout.
          });
        } catch {
          // Never let logging failures affect the actual checkout flow.
        }
      }
    }

    customElements.define('checkout-guard-component', CheckoutGuardComponent);
    if (!document.querySelector('checkout-guard-component')) {
      document.body.appendChild(document.createElement('checkout-guard-component'));
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["per-page-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('per-page-selector-component')) {
    class PerPageSelectorComponent extends HTMLElement {
      static STORAGE_KEY = 'silah:products-per-page';

      connectedCallback() {
        this.select = this.querySelector('[ref="select"]');
        if (!this.select) return;

        const stored = Number(sessionStorage.getItem(PerPageSelectorComponent.STORAGE_KEY));
        if (stored && [25, 50, 100].includes(stored)) {
          this.select.value = String(stored);
        }

        this.select.addEventListener('change', this.#handleChange);

        // If the visitor previously chose 50/100 in this session, restore
        // that view on fresh page loads too (e.g. navigating collection to collection).
        if (stored && stored > 25) {
          this.#expandTo(stored);
        }
      }

      disconnectedCallback() {
        this.select?.removeEventListener('change', this.#handleChange);
      }

      #handleChange = (event) => {
        const count = Number(event.target.value);
        if (!count) return;

        sessionStorage.setItem(PerPageSelectorComponent.STORAGE_KEY, String(count));
        this.#expandTo(count);
      };

      async #expandTo(count) {
        const list = this.closest('results-list');
        if (!list || typeof list.loadUntil !== 'function') return;

        this.select.disabled = true;
        try {
          await list.loadUntil(count);
        } finally {
          this.select.disabled = false;
        }
      }
    }

    customElements.define('per-page-selector-component', PerPageSelectorComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
